//Javascript for the WECAN Admin Report
app.Report = (
    function () {
        var report = {
            Index: function () {
                //unlock account button
                $(document).on('click', '[data-role="run-report"]', function () {
                    var form = $(this).closest('form');
                    //validate form
                    $.validator.unobtrusive.parse(form);
                    if (!form.valid()) {
                        //Give focus to the first error
                        var firstError = $('#' + $('.field-validation-error', form).data('valmsg-for'));
                        if (firstError.length) {
                            $('html, body').animate({
                                scrollTop: firstError.offset().top - 50
                            }, 500);
                        }
                        return;
                    }

                    var url = $(form).attr('action');
                    $.post(url, $(form).serialize())
                        .done(function (results) {
                            //refresh grid
                            $(form).closest('.row').find('[data-role="report-result"]').html(results.data);
                        })
                        .fail(function () {
                            toastr.error("Error!", "There was an error with your request. Please try again.");
                        });
                });
            },
            Lockout: function () {
                //unlock account button
                $(document).on('click keyup', "[data-label='Unlock'] button", function () {
                    var userId = $(this).closest('tr').find("input[type='hidden']").val();
                    $.post("/Account/UnlockAccount/" + userId)
                        .done(function () {
                            //refresh grid
                            app.page.componentActions.report[0].triggerAction("filtergrid");
                        })
                        .fail(function () {
                            toastr.error("Error!", "There was an error with your request. Please try again.");
                        });
                });

                //reset attempts button
                $(document).on('click keyup', "[data-label='ResetAttempts'] button", function () {
                    var userId = $(this).closest('tr').find("input[type='hidden']").val();
                    $.post("/Account/ResetAttempts/" + userId)
                        .done(function () {
                            //refresh grid
                            app.page.componentActions.report[0].triggerAction("filtergrid");
                        })
                        .fail(function () {
                            toastr.error("Error!", "There was an error with your request. Please try again.");
                        });
                });

                //bulk unlock
                $(document).on('click keyup', "#bulkUnlockButton", function () {
                    var ids = [];
                    //Get all checked checkboxes
                    var checked = $(".BulkUpdate:checked");
                    //get ids for those rows and put in array
                    checked.each(function(index, element) {
                        var userId = $(element).closest('tr').find("input[type='hidden']").val();
                        ids.push(userId);
                    });

                    $.post("/Account/BulkUnlock/", { ids: ids })
                        .done(function () {
                            //refresh grid
                            app.page.componentActions.report[0].triggerAction("filtergrid");
                        })
                        .fail(function () {
                            toastr.error("Error!", "There was an error with your request. Please try again.");
                        });
                });
            },
            AdminIndex: function () {
                app.Report.Index();

                $("path").click(function () {
                    var cesaNumber = $(this).closest("g.cesa-group-item").data("cesa-unique-id");
                    app.Report.SelectDistrictsByCesa(cesaNumber);
                });

                $("#fstSelectedDistrictIds").find("input").click(function () {
                    app.Report.SetHiddenDistrictList();

                });
                $("#SelectedDistrictIds-all").click(function() {
                    $(".selected-district-ids").val("");
                });
            },
            SelectDistrictsByCesa: function (cesaId) {
                $("#district-selector").removeClass("hidden").addClass("hidden");
                $("#district-selector-spinner").removeClass("hidden");

                var postData = { id: cesaId };
                var theUrl = app.page.appPath + "/Admin/Report/GetDistrictsByCesa";
                var districtIdArray = "";

                // Uncheck all district checkboxes.
                $("#fstSelectedDistrictIds").find("input:checked").click();

                $.ajax({
                    url: theUrl,
                    type: "POST",
                    data: postData,
                    success: function (response) {
                        for (var distId of response.split(",")) {
                            $("#SelectedDistrictIds-" + distId).click();
                        }
                    },
                    error: function (theError) {
                        //display toast on error
                        toastr.error("There was an error retrieving districts for CESA " + cesaId + ". Please try again and contact support if the problem persists.");
                    },
                    complete: function () {
                        $("#district-selector-spinner").removeClass("hidden").addClass("hidden");
                        $("#district-selector").removeClass("hidden");
                    }
                });
            },
            SetHiddenDistrictList: function() {
                $(".selected-district-ids").val("");

                var markedCheckbox = $("#fstSelectedDistrictIds :input:checked");
                for (var checkbox of markedCheckbox) {
                    $(".selected-district-ids").val($(".selected-district-ids").val() + checkbox.value + ",");
                }
            },
            SkywardDataExport: function () {
                $(document).on('component-filter-grid-completed', function () { app.Report.SkywardDataExportDownloadButton(); });
                $(document).on('change', '[name="ApplicationId"]', function () { app.Report.SkywardDataExportDownloadButton(); });
            },
            SkywardDataExportDownloadButton: function () {
                var downloadButton = $('[data-role="download-csv"]');
                if ($('[name="ApplicationId"]:checked').length > 0) {
                    $(downloadButton).prop('disabled', false);
                }
                else {
                    $(downloadButton).prop('disabled', true);
                }
            }
        };

        return report;
    }()
);